import React from "react";
import styled from "styled-components";
import { Test } from "consumerhouse-shared";
import { useLanguage } from "../useLanguage";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock, faMapMarkerAlt, IconDefinition } from "@fortawesome/free-solid-svg-icons";
import sanitizeHtml from "sanitize-html";

const Card = styled.div`
    background: #0001;
    border-radius: 1em;
    overflow: hidden;
    transition: 300ms;
    /* border: 2px solid #ffff; */

    @media only screen and (min-width: 600px) {
        &:hover {
            transition: 100ms;
            /* border: 2px solid rgb(211, 84, 95); */
            box-shadow: 3px 7px 10px #0003;
            /* transform: translateY(-2px); */
        }
    }
`;

type TestCardProps = {
    children?: React.ReactNode;
    test: Test;
    style?: React.CSSProperties;
    showReward?: boolean;
    showRegion?: boolean;
    onClick?: () => void;
    borderColor?: string;
    borderContent?: React.ReactNode;
    borderIcon?: IconDefinition;
};

const Title = styled.h2`
    display: inline-block;
    margin-right: auto;
`;

const Property = styled.span`
    font-weight: bold;
    margin-top: 0.2em;
    padding: 0 0.5em;
    text-transform: capitalize;
    opacity: 0.7;
`;

const Description = styled.div`
    /* overflow-x: hidden;
    box-shadow: -2px -2px inset black 10px;
    overflow-y: auto;
    height: 10em; */
    font-size: 1.1em;
    display: block;
    /* border-bottom: 1px solid rgb(211, 84, 95); */
    /* border-top: 1px solid rgb(211, 84, 95); */
    background: #0000000a;
    padding: 1.5em 1em;
`;

const Row = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    padding: 1em;
`;

const RewardContainer = styled.div`
    align-self: flex-end;
    display: flex;
    align-items: baseline;
    padding: 0.3em 0.8em;
    font-weight: bold;
    font-size: 1.2em;
    border-radius: 0.7em;
    margin-left: auto;
    background: #ec454f;

    @media only screen and (max-width: 600px) {
        font-size: 1em;
        /* flex-direction: column; */
    }
`;

const RewardText = styled.span`
    margin-right: 0.3em;
    padding: 0 0.1em;
    color: white;

    @media only screen and (max-width: 600px) {
        font-size: 0.9em;
    }
`;

const RewardAmount = styled.span`
    font-size: 1.4em;
    padding: 0 0.1em;

    color: white;
    /*color: #ec454f; */
`;

const BorderIcon = styled(FontAwesomeIcon)`
    opacity: 0.8;
    margin-right: 0.5em;
`;

const Border = styled.div`
    padding: 0.8em;
    color: white;
    font-weight: bold;
`;

const Container = styled.div`
    display: flex;

    @media only screen and (max-width: 850px) {
        flex-direction: column;
    }
`;

const ThumbContainer = styled.div`
    position: relative;
    flex-shrink: 0;

    width: 400px;
    @media only screen and (max-width: 850px) {
        width: unset;
        height: 200px;
        background-position: center center;
    }

    background-size: cover;
    background-position: center left;
`;

export default function TestCard({ style, test, children, onClick, showReward, showRegion, borderColor, borderContent, borderIcon }: TestCardProps) {
    const language = useLanguage();
    return (
        <Card onClick={onClick} style={{ ...style, border: borderColor ? `4px solid ${borderColor}` : "none" }}>
            {borderContent && (
                <Border style={{ background: borderColor }}>
                    {borderIcon && <BorderIcon icon={borderIcon} />} {borderContent}
                </Border>
            )}
            <Container>
                <div style={{ flexGrow: 1 }}>
                    <Row>
                        <Title>{test.name}</Title>
                        {showRegion && (
                            <Property>
                                <FontAwesomeIcon icon={faMapMarkerAlt} /> {test.inRegions.map((e) => e.regionName).join(", ")}
                            </Property>
                        )}
                        {/* <Property>
                    <FontAwesomeIcon icon={faGlobeEurope} /> {test.language}
                </Property> */}
                        {test.duration > 0 && (
                            <Property>
                                <FontAwesomeIcon icon={faClock} /> {test.duration} {language("test-duration-suffix")}
                            </Property>
                        )}
                    </Row>
                    {test.description && (
                        <Description dangerouslySetInnerHTML={{ __html: sanitizeHtml(test.description.replace(/\n/g, "<br />")) }} />
                    )}
                    <Row>
                        {children}
                        {test.reward > 0 && (showReward ?? true) && (
                            <RewardContainer>
                                <RewardText>{language("test-reward")}</RewardText>
                                <RewardAmount>€{Math.round(test.reward)},-</RewardAmount>
                            </RewardContainer>
                        )}
                    </Row>
                </div>
                {test.thumbnail && (
                    <ThumbContainer
                        style={{
                            backgroundImage: `url("${test.thumbnail}")`,
                        }}>
                        <div
                            style={{
                                background: "linear-gradient(to right, #0002, #0004, #0008)",
                                height: "100%",
                                width: "100%",
                            }}></div>
                    </ThumbContainer>
                )}
            </Container>
        </Card>
    );
}
